import { LicenseName } from "@/data/license.data";
import { ServiceUsingDurationLimiter } from "@/services/license/license-limiters/base-limiters/service-using-duration-limiter";

export const trialMaxTtmsDuration = 15;
export const defaultMaxTtmsDuration = 60;

export class TextToMusicDurationLimiter extends ServiceUsingDurationLimiter {
  getPlanUsingDurationLimit(license: LicenseName, duration: number): number {
    switch (license) {
      case "Trial":
        return trialMaxTtmsDuration;
      default:
        return defaultMaxTtmsDuration;
    }
  }
}
